import { Link } from 'react-redux-app/lib/modules/link/components';
import withLang from '../../containers/withLang';


export default withLang(Link);
